/* eslint-disable no-console */
import axios from 'axios';
import {HOST} from '../constants';
import {QuestionAnswersCount, QuestionReport} from '../incase-domain/analytics';
import {ISlidesAnalytics, SlidesAnalyticsData} from '../incase-domain/proptypes/slidesAnalytics';

export const saveSlideClicksData = (clicks: {
    slideId: string;
    runFileId: string;
    clicks: {x: number; y: number}[];
}): Promise<{success: boolean}> => {
    if (!clicks.clicks.length) return Promise.resolve({success: true});

    return axios
        .post(`${HOST}/player/analytics/slideClicks`, clicks)
        .then(() => {
            return {success: true};
        })
        .catch(() => {
            return {success: false};
        });
};

export const postForAnalyticsData = (searchForm: {id: string}): Promise<unknown> => {
    return axios
        .post(`${HOST}/player/analytics/postForAnalyticsData`, {data: searchForm})
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

/**
 * Fetches a question report for a specific element
 * @param elementId - The ID of the question element
 * @param roomRunfileId - Optional room runfile ID for filtering
 * @returns Promise with question report data
 */
export const fetchQuestionReport = (elementId: string, roomRunfileId?: string): Promise<QuestionReport> => {
    return axios
        .get(`${HOST}/player/reports/getQuestionReport/${elementId}`, {
            params: roomRunfileId ? {roomRunfileId} : undefined,
        })
        .then((response) => response.data)
        .catch((error) => {
            console.error(`Failed to fetch question report for element ${elementId}:`, error);
            throw error;
        });
};

export const fetchQuestionAnswersCount = (elementId: string, roomId: string, roomRunFileId: string): Promise<QuestionAnswersCount> => {
    return axios
        .get(`${HOST}/player/reports/getQuestionAnswersCount`, {
            params: {
                elementId,
                roomId,
                roomRunFileId,
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error fetching question answers count:', error);
            throw error;
        });
};

export const createSlidesAnalyticsService = (runFileId: string, presentationId: string): Promise<ISlidesAnalytics> => {
    return axios
        .post(`${HOST}/player/createSlidesAnalytics`, {runFileId, presentationId})
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchSlidesAnalytics = (runfileId: string): Promise<ISlidesAnalytics> => {
    return axios
        .get(`${HOST}/player/getSlidesAnalytics/${runfileId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const postSlidesAnalytics = (id: ISlidesAnalytics['_id'], SlidesAnalyticsData: SlidesAnalyticsData): Promise<void> => {
    return axios
        .put(`${HOST}/player/updateSlidesAnalytics/${id}`, SlidesAnalyticsData)
        .then(() => undefined)
        .catch((error) => {
            console.log(error);
        });
};
